<p-button [styleClass]="componentStyle"
      label="{{translatedLabel}}"
      [type]="type"
      [disabled]="disabled"
      (onClick)="handleClick($event)">
  <i *ngIf="icon" class="{{icon}}" aria-hidden="true"></i>
  <svg-icon class="aero-button__icon" *ngIf="svgIconKey" [key]="svgIconKey"></svg-icon>
</p-button>
